import { Box, Typography, useTheme } from "@mui/material";
import ActiveRequestCard from "./ActiveRequestCard";
import InfoTriangle from "../../../../../media/images/icons/info-triangle";
import InfoFillCircle from "../../../../../media/images/icons/infofill-circle";

export default function ActiveRequests() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <ActiveRequestCard />
      <ActiveRequestCard />
      <ActiveRequestCard />

      <Box
        sx={{
          mt: 1,
          borderWidth: "0.5px",
          borderStyle: "solid",
          borderColor: "info.main",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          padding: "8px",
          borderRadius: "10px",
          backgroundColor: "info.light",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mx: "auto",
            gap: "4px",
          }}
        >
          <InfoTriangle color={theme.palette.secondary.main} />
          <Typography
            color={"secondary.main"}
            sx={{
              fontSize: "14px",
            }}
          >
            به نکات زیر توجه داشته باشید
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "4px",
          }}
        >
          <InfoFillCircle size={18} color={theme.palette.primary.main} />
          <Typography
            sx={{
              fontSize: "12px",
            }}
          >
            با اعلام حضور، شما یک نوبت در بین دیگر رانندگان بر اساس زمانی اعلام
            حضور می‌کنید دریافت خواهید کردکه{" "}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "4px",
          }}
        >
          <InfoFillCircle size={18} color={theme.palette.primary.main} />
          <Typography
            sx={{
              fontSize: "12px",
            }}
          >
            با اعلام حضور، شما یک نوبت در بین دیگر رانندگان بر اساس زمانی اعلام
            حضور می‌کنید دریافت خواهید کردکه{" "}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "4px",
          }}
        >
          <InfoFillCircle size={18} color={theme.palette.primary.main} />
          <Typography
            sx={{
              fontSize: "12px",
            }}
          >
            با اعلام حضور، شما یک نوبت در بین دیگر رانندگان بر اساس زمانی اعلام
            حضور می‌کنید دریافت خواهید کردکه{" "}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
